import { PencilLine } from "lucide-react";
import moment from "moment";
import { useState } from "react";
import { Member } from "src/redux/types/_customer.type";
import { calculateAge } from "src/utils";
import BloodGroupEditForm from "./blood-group-edit-form";

const Field = ({ label, value }: { label: string; value: string }) => {
  return (
    <div className="grid grid-cols-2 w-full gap-2 border rounded-xl">
      <div className="text-start text-sm font-semibold px-3 py-1 border-r">
        {label}
      </div>
      <div className="text-start text-sm px-3 py-1">
        {label === "Date of Birth" ? moment(value).format("Do MMM YYYY") : value}
        {label === "Date of Birth" && value && (
          <span className="ml-4">Age: {calculateAge(value)}</span>
        )}
      </div>
    </div>
  );
};

const BasicInfo = ({
  member,
  updateSelected,
}: {
  member: Member;
  updateSelected: (member: Member) => void;
}) => {
  const name = `${member?.first_name} ${member?.middle_name} ${member?.last_name}`;

  const [editingBloodGroup, setEditingBloodGroup] = useState(false);

  return (
    <div className="border rounded-lg p-2 max-w-xl mx-auto mb-3 space-y-2 bg-card">
      <Field label="Name" value={name} />
      <Field
        label="Date of Birth"
        value={member?.dob}
      />
      <div className="grid grid-cols-2 w-full gap-2 border rounded-xl">
        <div className="text-start text-sm font-semibold px-3 py-1 border-r">
          Blood Group
        </div>
        <div className="flex items-center justify-between px-3 py-1">
          {editingBloodGroup ? (
            <BloodGroupEditForm
              member={member}
              subscriptionId={member.subscription_id}
              onDone={() => setEditingBloodGroup(false)}
              updateSelected={updateSelected}
            />
          ) : (
            <>
              <span className="text-sm">{member?.blood_group || "—"}</span>
              <button
                type="button"
                onClick={() => setEditingBloodGroup(true)}
                className="text-muted-foreground hover:text-primary transition"
                aria-label="Edit blood group"
              >
                <PencilLine className="w-3.5 h-3.5" />
              </button>
            </>
          )}
        </div>
      </div>
      <Field label="Gender" value={member?.gender} />
    </div>
  );
};

export default BasicInfo;
